import { gtmTrack } from './google-tracking';
import { type CheckoutT, type PageViewData } from './types';
import {
  sha256,
  isEmailProfessional,
  createPurchaseEventPayload,
} from './utils';

function trackAddTemplate(name: string) {
  gtmTrack({
    event: 'add_template',
    name,
  });
}

function trackNewPresentation(seriesId?: string) {
  gtmTrack({
    event: 'series_activated',
    type: 'create',
    series_id: seriesId,
  });
}
async function trackFirstPresentation(seriesId?: string, email?: string) {
  gtmTrack({
    event: 'series_activated',
    type: 'first_create',
    sha256_email_address: email && (await sha256(email)),
    series_id: seriesId,
  });
}

function trackWebinar(name: string) {
  gtmTrack({
    event: 'registration_webinar',
    name,
  });
}

function trackEnterpriseForm(type: string, form: string, placement?: string) {
  gtmTrack({
    event: 'form_interaction',
    form,
    type,
    placement,
  });
}

async function trackSignup(referral?: string, email?: string) {
  gtmTrack({
    event: 'sign_up',
    referral,
    sha256_email_address: email && (await sha256(email)),
    email_domain: isEmailProfessional(email),
  });
}

export function trackGenerateLead(placement?: string, email?: string) {
  gtmTrack({
    event: 'generate_lead',
    placement,
    email_domain: isEmailProfessional(email),
  });
}

export function trackPageView({
  user_purpose,
  plan_type,
  ...data
}: PageViewData) {
  gtmTrack({
    event: 'pageview',
    user_purpose: user_purpose || 'not available',
    plan_type: plan_type || 'not available',
    ...data,
  });
}

export function trackSubscriptionPurchase(data: CheckoutT) {
  gtmTrack({
    ...createPurchaseEventPayload(data, 'new'),
  });
}

export function trackAddLicenses(data: CheckoutT) {
  gtmTrack({
    ...createPurchaseEventPayload(data, 'additional_licenses'),
  });
}

export function trackPlanUpgrade(data: CheckoutT) {
  gtmTrack({
    ...createPurchaseEventPayload(data, 'upgrade'),
  });
}

export const TrackingMethods = {
  trackAddTemplate,
  trackNewPresentation,
  trackFirstPresentation,
  trackWebinar,
  trackEnterpriseForm,
  trackGenerateLead,
  trackSignup,
  trackPageView,
};
